import React from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CrudContent from './CrudContent'

const ContentPage = () => {
    const { t } = useTranslation()

    return (
        <CMS>
            <PageBanner
                title={t("content_management")}
                description={t("content_management_des")}
            />

            <CrudContent />
        </CMS>
    )
}

export default ContentPage
